<template>
    <div class="md:max-w-fit" :class="minified ? 'space-y-6' : 'space-y-6 sm:space-y-10'">
        <slot />

        <CardResponseTimeBlock :preview="preview" :user="profile" />

        <slot name="footer" />
    </div>
</template>

<script setup lang="ts">
import type { UserProfile } from '#shared/types/User'

interface Props {
    profile: UserProfile
    minified?: boolean
    preview?: boolean
}

defineProps<Props>()
</script>
